var mountElement = document.querySelector('#size-calculator-app');
var app = new Vue({
  el: '#size-calculator-app',
  data() {
    return {
      availableSizes: mountElement.getAttribute('size-options').split('|'),
      optionName: mountElement.getAttribute('option-name'),
      showingResults: false,

      unit: 'inches',
      form: {},
      title: 'Size calculator',
      intro: 'Use this size calculator to discover the perfect pump for you. Learn how to correctly measure yourself',
      recommendation: {},
      selectedSize: null,
      showingSizeGuide: false
    }
  },
  computed: {
    isFormValid() {
      return (this.form.length && this.form.length > 0) && (this.form.girth && this.form.girth > 0);
    },
    matchedSizes() {
      if (!this.form.length && !this.form.girth) {
        return this.availableSizes;
      }

      const lengthValue = this.unit === 'centimeters' ? parseFloat(this.form.length / 2.5) : parseFloat(this.form.length);
      console.log("lengthValue",lengthValue);
      const girthValue = this.unit === 'centimeters' ? parseFloat(this.form.girth / 2.5) : parseFloat(this.form.girth);
      console.log("girthValue",girthValue);

      return this.availableSizes.filter((size) => {
        const sizeValue = this.mapSizeToValue(size);

        if (lengthValue <= 3) {

        if (girthValue <= 6) {
                  return [3].includes(sizeValue);
        }
        
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
        
        }
        
        if (lengthValue < 3.5) {
        
        if (girthValue <= 6) {
                  return [3,5].includes(sizeValue);
        }
        
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
        
        }
        
        if (lengthValue < 5) {
        
        if (girthValue <= 6) {
                  return [5].includes(sizeValue);
        }
        
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
        
        }
        
        if (lengthValue < 5.5) {
        
        if (girthValue <= 6) {
                  return [5,6].includes(sizeValue);
        }
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
        
        }
        
        
        if (lengthValue < 6) {
        
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return ['7wb'].includes(sizeValue);
        }
        
        
        }
        
        if (lengthValue < 6.5) {
        
        if (girthValue <= 6.5) {
                  return [6,7].includes(sizeValue);
        }
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return ['7wb'].includes(sizeValue);
        }
        
        
        }
        
        if (lengthValue < 7) {
        
        if (girthValue <= 6.5) {
                  return [7].includes(sizeValue);
        }
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return ['7wb'].includes(sizeValue);
        }
        
        
        }
        
        if (lengthValue < 7.5) {
        
        if (girthValue <= 6.5) {
                  return [7,8].includes(sizeValue);
        }
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return ['7wb'].includes(sizeValue);
        }
        
        
        }
        
        if (lengthValue < 8) {
        
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return [9].includes(sizeValue);
        }
        
        
        }
        
        if (lengthValue < 8.5) {
        
        if (girthValue <= 7) {
                  return [8,9].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return [9].includes(sizeValue);
        }
        
        
        }
        
        if (lengthValue < 9.5) {
        
        if (girthValue <= 7.5) {
                  return [9,11].includes(sizeValue);
        }
        
        
        }

        return false;
      }).sort();
    }
  },
  methods: {
    getResults() {
      this.setRecommendation();
      this.showingResults = true;
      document.getElementById('size-calc-img').style.display = 'none';
      document.getElementById('custom-image-with-text').style.display = 'none';
      document.getElementById('custom-shop-now').disabled = true;
      if(this.matchedSizes.length){
        if (window.innerWidth <= 900) {
          const slideDiv = document.getElementById('custom-padd-sizearea');
          setTimeout(() => {
                 window.scrollTo({
                  top: this.getOffsetTop(slideDiv),
                  left: 0,
                  behavior: 'smooth'  // makes the scroll smooth
                });
            }, 50);
        }
        document.getElementById('custom-padd-sizearea').classList.add('padd_active');
        document.getElementById('custom-no-size').classList.remove('custom-additional-no-size');
      }else{
          if (window.innerWidth <= 900) {
  
             const slideDiv = document.getElementById('custom-no-size');
             setTimeout(() => {
                 window.scrollTo({
                  top: this.getOffsetTop(slideDiv),
                  left: 0,
                  behavior: 'smooth'  // makes the scroll smooth
                });
            }, 50);

          }
        
          document.getElementById('custom-no-size').classList.add('custom-additional-no-size');
          document.getElementById('custom-padd-sizearea').classList.remove('padd_active');
          this.form.length = '';
          this.form.girth = '';
      }
    },
    setRecommendation() {
      const lengthValue = this.unit === 'centimeters' ? parseFloat(this.form.length / 2.5) : parseFloat(this.form.length);
      const girthValue = this.unit === 'centimeters' ? parseFloat(this.form.girth / 2.5) : parseFloat(this.form.girth);

      const recommendedSize = () => {
        switch (true) {
          case (girthValue <= 5.5 && lengthValue <= 3):
            return [3];
          case (girthValue <= 6 && lengthValue <= 5):
            return [5];
          case (girthValue <= 6.5 && lengthValue <= 6):
            return [6];
          case (girthValue <= 6 && lengthValue <= 7):
            return [7];
          case (girthValue <= 7.5 && lengthValue <= 7):
            return ['7wb'];
          case (girthValue <= 7 && lengthValue <= 8):
            return [8];
          case (girthValue <= 7.5 && lengthValue <= 9.5):
            return [9];
         case (girthValue <= 8.5 && lengthValue <= 10.5):
            return [11];
          default:
            return [];
        }
      }

      this.recommendation = this.availableSizes.find((size) => recommendedSize().includes(this.mapSizeToValue(size)));
      document.getElementById('recommendation').innerText = this.recommendation;
      document.getElementById('custom-length').innerText = this.form.length;
      document.getElementById('custom-length-unit').innerText = this.unit;
      document.getElementById('custom-girth').innerText = this.form.girth;
      document.getElementById('custom-girth-unit').innerText = this.unit;
    
      const container = document.querySelector('#custom-size-calculator__matches');
      container.innerHTML = '';
  
      if(this.matchedSizes.length){
        console.log("matchedSizes",this.matchedSizes);
        for (const index of this.matchedSizes) {
          
            const sizeDiv = document.createElement('div');
            sizeDiv.className = 'size-calculator__option';
            const span = document.createElement('span');
            span.className = 'size-calculator__option-size';
            span.innerText = index;
            sizeDiv.addEventListener('click', function (e) {
              e.preventDefault();
              document.querySelectorAll('.size-calculator__option').forEach(el => {
                el.classList.remove('size-calculator__option--active');
              });
              this.classList.toggle('size-calculator__option--active');
              document.getElementById('custom-shop-now').disabled = false;
            });
            sizeDiv.appendChild(span);
            container.appendChild(sizeDiv);
            this.restart();
        }
        
      }
    },
    setUnit(unit) {
      this.unit = unit;
    },
    slideDown(el, duration = 200){
      el.style.removeProperty('display');
      let display = window.getComputedStyle(el).display;
      if (display === 'none') display = 'block';
    
      let height = el.scrollHeight;
      el.style.height = '0px';
      el.style.overflow = 'hidden';
      el.style.transition = `height ${duration}ms ease-in-out`;

      void el.offsetHeight; // This line forces reflow
    
      requestAnimationFrame(() => {
        el.style.height = height + 'px';
      });
    
      setTimeout(() => {
        el.style.height = null;
        el.style.overflow = null;
        el.style.transition = null;
      }, duration);
    },
    slideUp(el, duration = 200){
      let height = el.scrollHeight;
      el.style.height = height + 'px';
      el.style.overflow = 'hidden';
      el.style.transition = `height ${duration}ms ease-in-out`;

      el.offsetHeight; // This line forces reflow
    
      requestAnimationFrame(() => {
        el.style.height = '0px';
      });
    
      setTimeout(() => {
        el.style.display = 'none';
        el.style.height = null;
        el.style.overflow = null;
        el.style.transition = null;
      }, duration);
    },
    getOffsetTop(el){
      let offsetTop = 0;
      while (el) {
        offsetTop += el.offsetTop;  // Add the current element's top offset
        el = el.offsetParent;   // Move up to the offset parent
      }
      return offsetTop;   // Return the total offset from the top of the document
    },
    mapSizeToValue(size) {
      const intVal = parseFloat(size.replace(/\D/g, ""));    
      const plusRegex = new RegExp("wb", "i");

      if (plusRegex.test(size)) {
          return `${intVal}wb`;
      }
  
      return intVal;
    },
    restart() {
      this.form = {};
      this.showingResults = false;
    },
    toggleSizeGuide() {
      this.showingSizeGuide = !this.showingSizeGuide;
    },
    hideSizeGuide() {
      this.showingSizeGuide = false;
    }
  },
  mounted() {
    document.body.addEventListener('modalClosed', this.hideSizeGuide);
  },
  unmounted() {
    document.body.removeEventListener('modalClosed', this.hideSizeGuide);
  },
  delimiters: ['${', '}'],
})